/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Occupancy_MediumInputs */

const fr_marker_occupancy_medium = /** @type {(inputs: Marker_Occupancy_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affluence moyenne`)
};

const en_marker_occupancy_medium = /** @type {(inputs: Marker_Occupancy_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium occupancy`)
};

/**
* | output |
* | --- |
* | "Medium occupancy" |
*
* @param {Marker_Occupancy_MediumInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_occupancy_medium = /** @type {((inputs?: Marker_Occupancy_MediumInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Occupancy_MediumInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_occupancy_medium(inputs)
	return en_marker_occupancy_medium(inputs)
});